export class AccountantPouchEntity {
  id?: number
  userId?: string
  userDisplayName?: string | null
  amount?: number
}
